import React from "react";
import dynamic from "next/dynamic";
import { useTranslation } from "react-i18next";
import SHeading from "@/components/atoms/SHeading";
import { SText } from "@/components/atoms";
const VietNamMapV1 = dynamic(() => import("./VietnamMap"), {
  loading: () => <div className="w-full h-auto bg-gray-100 animate-pulse" />,
});
const GlobalPartnerships = () => {
  const { t } = useTranslation();
  const provinceData: Record<string, ProvinceData> = {
    "VN-87": {
      value: 1,
      color: "#ff6b98",
      description: t("provinces.DONG_THAP"),
    },
    "VN-12": {
      value: 1,
      color: "#ff6b98",
      description: t("provinces.LAI_CHAU"),
    },
    "VN-26": {
      value: 1,
      color: "#ffa0c2",
      description: t("provinces.VINH_PHUC"),
    },
    "VN-1": {
      value: 32,
      color: "#ff6b98",
      description: t("provinces.HA_NOI"),
    },
    "VN-15": {
      value: 1,
      color: "#ff6b98",
      description: t("provinces.YEN_BAI"),
    },
    "VN-27": {
      value: 2,
      color: "#ff6b98",
      description: t("provinces.BAC_NINH"),
    },
    "VN-36": {
      value: 1,
      color: "#ffa0c2",
      description: t("provinces.NAM_DINH"),
    },
    "VN-31": {
      value: 7,
      color: "#ffa0c2",
      description: t("provinces.HAI_PHONG"),
    },
    "VN-33": {
      value: 3,
      color: "#ffa0c2",
      description: t("provinces.HUNG_YEN"),
    },
    "VN-75": {
      value: 6,
      color: "#ffa0c2",
      description: t("provinces.DONG_NAI"),
    },
    "VN-30": {
      value: 3,
      color: "#ffa0c2",
      description: t("provinces.HAI_DUONG"),
    },
    "VN-22": {
      value: 7,
      color: "#ffa0c2",
      description: t("provinces.QUANG_NINH"),
    },
    "VN-8": {
      value: 3,
      color: "#ffa0c2",
      description: t("provinces.TUYEN_QUANG"),
    },
    "VN-2": {
      value: 1,
      color: "#ffa0c2",
      description: t("provinces.HA_GIANG"),
    },
    "VN-94": {
      value: 1,
      color: "#ff6b98",
      description: t("provinces.SOC_TRANG"),
    },
    "VN-79": {
      value: 7,
      color: "#ff6b98",
      description: t("provinces.HO_CHI_MINH"),
    },
    "VN-38": {
      value: 2,
      color: "#ff6b98",
      description: t("provinces.THANH_HOA"),
    },

    "VN-40": {
      value: 2,
      color: "#ffa0c2",
      description: t("provinces.NGHE_AN"),
    },
    "VN-54": {
      value: 1,
      color: "#ffa0c2",
      description: t("provinces.PHU_YEN"),
    },
    "VN-44": {
      value: 2,
      color: "#ffa0c2",
      description: t("provinces.QUANG_BINH"),
    },
    "VN-77": {
      value: 1,
      color: "#ffa0c2",
      description: t("provinces.BA_RIA_VUNG_TAU"),
    },
    "VN-68": {
      value: 3,
      color: "#ffa0c2",
      description: t("provinces.LAM_DONG"),
    },
    "VN-64": {
      value: 3,
      color: "#ffa0c2",
      description: t("provinces.GIA_LAI"),
    },
    "VN-34": {
      value: 2,
      color: "#ffa0c2",
      description: t("provinces.THAI_BINH"),
    },
    "VN-74": {
      value: 1,
      color: "#ffa0c2",
      description: t("provinces.BINH_DUONG"),
    },
    "VN-10": {
      value: 1,
      color: "#ffa0c2",
      description: t("provinces.LAO_CAI"),
    },
    "VN-83": {
      value: 1,
      color: "#ffa0c2",
      description: t("provinces.BEN_TRE"),
    },
    "VN-48": {
      value: 2,
      color: "#ffa0c2",
      description: t("provinces.DA_NANG"),
    },
    "VN-96": {
      value: 1,
      color: "#ffa0c2",
      description: t("provinces.CA_MAU"),
    },
    "VN-92": {
      value: 2,
      color: "#ffa0c2",
      description: t("provinces.CAN_THO"),
    },
    "VN-25": {
      value: 3,
      color: "#ffa0c2",
      description: t("provinces.PHU_THO"),
    },
    "VN-49": {
      value: 3,
      color: "#ffa0c2",
      description: t("provinces.QUANG_NAM"),
    },
    "VN-51": {
      value: 1,
      color: "#ffa0c2",
      description: t("provinces.QUANG_NGAI"),
    },
    "VN-20": {
      value: 1,
      color: "#ffa0c2",
      description: t("provinces.LANG_SON"),
    },
    "VN-14": {
      value: 1,
      color: "#ffa0c2",
      description: t("provinces.SON_LA"),
    },
  };

  return (
    <section className="mt-6 px-4">
      <div className="max-w-7xl mx-auto">
        <SHeading
          tAlign="center"
          className="font-bold md:text-3xl text-xl mb-3"
        >
          <span
            dangerouslySetInnerHTML={{
              __html: t("home.global_partnerships.title"),
            }}
          />
        </SHeading>
        <SText
          className="text-center font-light mb-5 mx-auto max-w-[600px]"
          text={t("home.global_partnerships.description")}
        />

        <div className="gap-8">
          <div className="partner-list flex flex-col lg:flex-row md:justify-between lg:justify-center p-4">
            <div className="md:ml-20 ml-0">
              <h3 className="text-2xl lg:text-left text-center whitespace-nowrap font-semibold mb-6">
                {t("map.partner_global")}
              </h3>
              <div className="grid mb-6 md:mb-0 grid-cols-2 gap-1 sm:justify-items-center px-4 lg:justify-items-start">
                {Object.entries(provinceData).map(([code, province]) => (
                  <div key={code} className="flex mr-4 justify-center gap-5">
                    <SHeading
                      text={`${province.description} (${province.value})`}
                      tAlign="left"
                      className="font-bold md:text-md text-sm whitespace-nowrap"
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="map-container  md:ml-20 block">
              <VietNamMapV1 provinceData={provinceData} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalPartnerships;
